import React, { useEffect, useState } from 'react'
import OttImageComponent from './OttImageComponent'
import RenderOttLink from './RenderOttLink'

const OttLinkField = props => {
  const {
    Movielinks,
    ott,
    links,
    defaultBehaviourEnter,
    removeFields,
    link,
    setOttindex,
    setPop,
    ottStatus,
    inputData,
    sendinputdata,
    sendBooleanValueChangeDone,
  } = props

  const [ottFreeStatus, setOttFreeStatus] = useState(
    Array(Movielinks.length).fill(false),
  )

  const handleFreeStatusChange = index => {
    const updatedStatus = [...ottFreeStatus]
    updatedStatus[index] = !updatedStatus[index]
    setOttFreeStatus(updatedStatus)

    const updatedLinks = [...Movielinks]
    if (updatedStatus[index]) {
      updatedLinks[index].link += '|free'
    } else {
      updatedLinks[index].link = updatedLinks[index].link.replace('|free', '')
    }

    links(updatedLinks[index].link, index)
  }

  // const renderOttLink = (input, index) => {
  //   const ottPlatform = ott[index]?.value || ''
  //   const ottLink = Movielinks[index]?.link || ''
  //   const ottLinkSplit = ottLink.split('|free')[0]

  //   const [selectedLanguages, setSelectedLanguages] = useState([])

  //   const handleLinkChange = event => {
  //     if (ottFreeStatus[index]) {
  //       links(event.target.value.trim() + '|free', index)
  //     } else {
  //       links(event.target.value.trim(), index)
  //     }
  //   }

  //   const handleLanguageChange = language => {
  //     const selectedIndex = selectedLanguages.indexOf(language)
  //     if (selectedIndex === -1) {
  //       setSelectedLanguages([...selectedLanguages, language])
  //     } else {
  //       const newLanguages = [...selectedLanguages]
  //       newLanguages.splice(selectedIndex, 1)
  //       setSelectedLanguages(newLanguages)
  //     }
  //   }

  //   const handleImageClick = () => {
  //     setOttindex(index)
  //     setPop(true)
  //   }

  //   const isFree = ottFreeStatus[index]

  //   const languages = ['English', 'Spanish', 'French', 'German'] // Example languages, replace with your own list

  //   return (
  //     <div className='cast' key={index}>
  //       <label>{`Ott links ${index + 1}`}</label>
  //       <div
  //         style={{
  //           display: 'flex',
  //           justifyContent: 'space-evenly',
  //           alignItems: 'center',
  //         }}
  //       >
  //         <OttImageComponent
  //           handleImageClick={handleImageClick}
  //           ottPlatform={ottPlatform}
  //         />

  //         <input
  //           type='url'
  //           value={ottLinkSplit}
  //           placeholder='ott link'
  //           onChange={handleLinkChange}
  //           onKeyDown={defaultBehaviourEnter}
  //           className='rounded'
  //           style={{ width: '100%' }}
  //         />

  //         <label>
  //           Free:
  //           <input
  //             type='checkbox'
  //             checked={isFree}
  //             onChange={() => handleFreeStatusChange(index)}
  //             onKeyDown={defaultBehaviourEnter}
  //           />
  //         </label>

  //         {languages.map(language => (
  //           <label key={language}>
  //             {language}
  //             <input
  //               type='checkbox'
  //               checked={selectedLanguages.includes(language)}
  //               onChange={() => handleLanguageChange(language)}
  //             />
  //           </label>
  //         ))}

  //         {Movielinks.length > 0 && (
  //           <button
  //             className='remove btn btn-danger ottCancelButton'
  //             onClick={() => removeFields(index)}
  //           >
  //             X
  //           </button>
  //         )}
  //       </div>
  //       {!(ottPlatform && ottLink.length >= 8) && (
  //         <span className='mandatory1'>
  //           Ott platform and Ott link are mandatory when one of them is selected
  //         </span>
  //       )}
  //       {/* {!link && <span className='mandatory1'>Enter a valid URL</span>} */}
  //     </div>
  //   )
  // }

  const renderOnlyOtt = (input, index) => {
    const ottPlatform = ott[index]?.value || ''

    const handleImageClick = () => {
      setOttindex(index)
      setPop(true)
    }

    return (
      <div className='cast' key={index}>
        <label>{`Ott Provider ${index + 1}`}</label>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
          }}
        >
          {
            <OttImageComponent
              handleImageClick={handleImageClick}
              ottPlatform={ottPlatform}
            />
          }

          {Movielinks.length > 0 && (
            <button
              className='remove btn btn-danger ottCancelButton'
              onClick={() => removeFields(index)}
            >
              X
            </button>
          )}
        </div>
      </div>
    )
  }

  useEffect(() => {
    const updatedStatus = Movielinks.map(item => item.link.includes('|free'))
    setOttFreeStatus(updatedStatus)
  }, [Movielinks])
  return (
    <>
      {<label> Otts:</label>}
      {(ottStatus?.value ===
        'OTTProviderDateAndLinkAvailable' ||
        ottStatus?.value ===
          'OTTProviderRevealedAndLinkAvailableAndDateNotKnown') &&
        Movielinks.map((input, index) => (
          <RenderOttLink
            key={index}
            ott={ott}
            Movielinks={Movielinks}
            ottFreeStatus={ottFreeStatus}
            setOttindex={setOttindex}
            setPop={setPop}
            defaultBehaviourEnter={defaultBehaviourEnter}
            links={links}
            handleFreeStatusChange={handleFreeStatusChange}
            removeFields={removeFields}
            input={input}
            index={index}
            inputData={inputData}
            sendinputdata={sendinputdata}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            link={link}
          />
        ))}
      {(ottStatus?.value === 'OTTProviderRevealedAndDateTBA' ||
        ottStatus?.value ===
          'OTTProviderRevealedAndDateAnnounced' ||
        ottStatus?.value ===
          'OTTProviderAndDateKnownAndLinkNotAvailable') &&
        Movielinks.map(renderOnlyOtt)}
    </>
  )
}

export default OttLinkField
